export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function deleteUrlSearchParams(url, params) {
  const urlObject = new URL(url);

  if (typeof params === 'string') {
    urlObject.searchParams.delete(params);
  } else if (Array.isArray(params)) {
    params.forEach((param) => {
      urlObject.searchParams.delete(param);
    });
  } else {
    throw new Error('Params must be either "string" type or an array of strings.');
  }

  return urlObject.href;
}

export function formatNumber(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function getCookie(name) {
  const r = document.cookie.match('\\b' + name + '=([^;]*)\\b');
  return r ? r[1] : undefined;
}

export function getScrollbarWidth() {
  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
}

export function isInViewport(el, partial = true, offset = 0) {
  const rect = el.getBoundingClientRect();
  const height = el.offsetHeight;
  const windowHeight = window.innerHeight;

  // Partially visible
  if (partial || height > windowHeight) {
    return rect.top <= windowHeight - offset && rect.bottom >= 0;
  }

  // Fully visible
  return rect.top >= 0 && rect.bottom <= windowHeight;
}

// Detect Safari
// https://www.geeksforgeeks.org/how-to-detect-the-user-browser-safari-chrome-ie-firefox-and-opera-using-javascript/
export function isSafari() {
  let userAgentString = navigator.userAgent;
  let chromeAgent = userAgentString.indexOf('Chrome') > -1;
  let safariAgent = userAgentString.indexOf('Safari') > -1;

  if (chromeAgent && safariAgent) safariAgent = false;

  return safariAgent;
}

export function pluralize(count, words) {
  const cases = [2, 0, 1, 1, 1, 2];
  return count + ' ' + words[count % 100 > 4 && count % 100 < 20 ? 2 : cases[Math.min(count % 10, 5)]];
}

export function stripTrailingSlash(str) {
  return str.endsWith('/') ? str.slice(0, -1) : str;
}
